module.exports = __webpack_public_path__ + "static/media/BackgroundImgTestResultFirst.07fe9ab5.svg";